import React, { FC } from 'react';
import Link from 'next/link';
import Icon from '../Icon';
import { ICustomTabBarItem } from './types';
import {
  TabBarListItem,
  TabBarLink,
  TabBarIconWrapper,
  TabBarLinkText
} from './styled';

interface TabBarItemServerProps {
  item: ICustomTabBarItem;
}

export const TabBarItemServer: FC<TabBarItemServerProps> = ({ item }) => {
  const {
    path,
    name,
    icon,
    text,
    isLink,
    isDefaultLink,
    iconW,
    iconH,
    isProfileTab
  } = item;

  const onClickDivContainerHandler = () => {};

  const tabBarItemContent = (
    <>
      <TabBarIconWrapper>
        <Icon
          indent={false}
          width={iconW}
          height={iconH}
          color={name === 'home' ? 'dark' : 'brown'}
          IconComponent={icon}
        />
      </TabBarIconWrapper>
      <TabBarLinkText>{text}</TabBarLinkText>
    </>
  );

  if (isProfileTab) {
    return (
      <TabBarListItem>
        <TabBarLink
          role="button"
          onKeyPress={onClickDivContainerHandler}
          onClick={onClickDivContainerHandler}
          tabIndex={0}
          data-stat="tab-bar-login-link"
        >
          {tabBarItemContent}
        </TabBarLink>
      </TabBarListItem>
    );
  }

  if (isDefaultLink) {
    return (
      <TabBarListItem>
        <a
          href="/items/new"
          data-stat="new-item-bar-link"
          style={{ textDecoration: 'none' }}
        >
          <TabBarLink centered>{tabBarItemContent}</TabBarLink>
        </a>
      </TabBarListItem>
    );
  }

  if (isLink) {
    return (
      <TabBarListItem>
        <Link
          href={path}
          data-stat={`${name}-bar-link`}
          style={{ textDecoration: 'none' }}
        >
          <TabBarLink as="div">{tabBarItemContent}</TabBarLink>
        </Link>
      </TabBarListItem>
    );
  }

  return (
    <TabBarListItem>
      <TabBarLink
        role="button"
        onKeyPress={onClickDivContainerHandler}
        onClick={onClickDivContainerHandler}
        tabIndex={0}
        data-stat={`${name}-bar-button`}
      >
        {tabBarItemContent}
      </TabBarLink>
    </TabBarListItem>
  );
};
